import React, { useId } from 'react';
import { ModalRoot } from './ModalRoot';
import './BaseModal.css';

interface BaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  className?: string;
  initialFocusRef?: React.RefObject<HTMLElement | HTMLInputElement | HTMLTextAreaElement | HTMLButtonElement | null>;
  'data-testid'?: string;
}

export const BaseModal: React.FC<BaseModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  className = '',
  initialFocusRef,
  'data-testid': dataTestId
}) => {
  const titleId = useId();

  if (!isOpen) {
    return null;
  }

  const modalClasses = `modal-content ${className}`.trim();

  return (
    <ModalRoot
      onClose={onClose}
      labelledBy={titleId}
      initialFocusRef={initialFocusRef}
      overlayClassName="modal-overlay"
      dialogClassName={modalClasses}
      data-testid={dataTestId}
    >
        <div className="modal-header">
          <h3 id={titleId}>{title}</h3>
          <button
            onClick={onClose}
            className="modal-close-button"
            aria-label={`Close ${title.toLowerCase()} modal`}
          >
            ×
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
    </ModalRoot>
  );
};
